var _circle, _circle2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPumpBoosterStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.4402,
    cy: 17.0926,
    r: 4.94021,
    stroke: "#637381"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.4401,
    cy: 17.0913,
    r: 4.56978,
    fill: "#2486FD",
    fillOpacity: 0.2,
    stroke: "#1070CA",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3696 8.69531H16.8805V17.0649L15.9389 14.6237L14.3696 12.8801V8.69531Z",
    fill: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 5.34766L18.1619 7.85852H13.0881L15.625 5.34766Z",
    fill: "#CBDFF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 2L18.1619 4.51087H13.0881L15.625 2Z",
    fill: "#CBDFF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPumpBoosterStation);
export default __webpack_public_path__ + "static/media/pump_booster_station.dbc3b40ed5524f1388af8394be3fc918.svg";
export { ForwardRef as ReactComponent };